import { render, staticRenderFns } from "./get.vue?vue&type=template&id=4bfe181e&scoped=true"
import script from "./get.vue?vue&type=script&lang=js"
export * from "./get.vue?vue&type=script&lang=js"
import style0 from "./get.vue?vue&type=style&index=0&id=4bfe181e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe181e",
  null
  
)

export default component.exports